module.exports = require('./src/containers/banner/banner.tag');
